module.exports = Promise.all([__parcel__import__("i34GE"), __parcel__import__("2uCom")]).then(() => parcelRequire('hh7cD'));